module.exports = __webpack_public_path__ + "static/media/background1.00105ba4.png";